<template>
  <!-- Skeleton loader -->
  <div class="loading-skeleton">
    <!-- Simulación de dropdowns superiores -->
    <div class="form-grid">
      <div class="form-field">
        <Skeleton width="140px" height="1.5rem" class="mb-2" />
        <Skeleton width="100%" height="2.5rem" />
      </div>
      <div class="form-field">
        <Skeleton width="130px" height="1.5rem" class="mb-2" />
        <Skeleton width="100%" height="2.5rem" />
      </div>
    </div>

    <!-- Simulación de campos de texto -->
    <div class="mt-4 form-grid">
      <div class="form-field">
        <Skeleton width="140px" height="1.5rem" class="mb-2" />
        <Skeleton width="100%" height="2.5rem" />
      </div>
      <div class="form-field">
        <Skeleton width="130px" height="1.5rem" class="mb-2" />
        <Skeleton width="100%" height="2.5rem" />
      </div>
    </div>

    <div class="mt-4 form-grid">
      <div class="form-field">
        <Skeleton width="140px" height="1.5rem" class="mb-2" />
        <Skeleton width="100%" height="2.5rem" />
      </div>
      <div class="form-field">
        <Skeleton width="130px" height="1.5rem" class="mb-2" />
        <Skeleton width="100%" height="2.5rem" />
      </div>
    </div>

    <div class="mt-4 form-grid">
      <div class="form-field">
        <Skeleton width="140px" height="1.5rem" class="mb-2" />
        <Skeleton width="50%" height="2.5rem" />
      </div>
    </div>

    <!-- Simulación de imagen -->
    <div class="mt-4">
      <Skeleton width="150px" height="1.5rem" class="mb-2" />
      <div class="document-preview">
        <Skeleton width="300px" height="200px" />
      </div>
    </div>

    <!-- Simulación de botones footer -->
    <div class="mt-4 flex justify-content-end">
      <Skeleton width="120px" height="2.5rem" class="mr-2" />
      <Skeleton width="120px" height="2.5rem" />
    </div>
  </div>
</template>
<style scoped>
.loading-skeleton {
  padding: 1.5rem;
}

.loading-skeleton .form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
}

.loading-skeleton .form-field {
  margin-bottom: 1rem;
}

.loading-skeleton .mt-4 {
  margin-top: 1.5rem;
}

.loading-skeleton .mb-2 {
  margin-bottom: 0.5rem;
}

.loading-skeleton .mr-2 {
  margin-right: 0.5rem;
}

.loading-skeleton .flex {
  display: flex;
}

.loading-skeleton .justify-content-end {
  justify-content: flex-end;
}

.loading-skeleton .document-preview {
  margin-top: 1rem;
  display: flex;
  justify-content: center;
}
</style>